export default [
    {
      title: 'Create GitHub issue',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'Link GitHub issue',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'Notify GitHub issue',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'View Issue History and status',
      plus: '<i class="fas fa-check text-success"></i>',
      pro: '<i class="fas fa-check text-success"></i>',
      premium: '<i class="fas fa-check text-success"></i>'
    },
    {
      title: 'Unlink Issue',
      plus: '-',
      pro: '-',
      premium: '<i class="fas fa-check text-success">'
    },
    {
      title: 'Users access',
      plus: '<span class="text-sm text-light">Valid upto 5 users</span>',
      pro: '<span class="text-sm text-light">Valid upto unlimited users</span>',
      premium: '<span class="text-sm text-light">Valid upto 10 users</span>'
    },
    {
      title: 'Issues Count',
      plus: '<span class="text-sm text-light">Valid upto 100 issues</span>',
      pro: '<span class="text-sm text-light">Valid upto 20 issues/agent/month</span>',
      premium: '<span class="text-sm text-light">Valid upto 300 issues</span>'
    },
    {
      title: '24*7 SLA support',
      plus: '<span class="text-sm text-light">Limited Support</span>',
      pro: '<span class="text-sm text-light">Limited Support</span>',
      premium: '<i class="fas fa-check text-success">'
    },
    {
      title: 'Access to repositories',
      plus: '<span class="text-sm text-light">Valid upto 5 repositories</span>',
      pro: '<span class="text-sm text-light">Valid upto 5 repositories</span>',
      premium: '<span class="text-sm text-light">Valid upto 20 repositories</span>',
    },
    {
      title: 'Two-way Comment Sync',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+50$ per month)</span>'
    },
    {
      title: 'GitHub Sync Status (Only Closed)',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+20$ per month)</span>'
    },
    {
      title: 'Freshservice Change Requests Integration',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Upload Files',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">(+25$ per month)</span>'
    },
    {
      title: 'Multiple Brands Support',
      plus: '-',
      pro: '<span class="text-sm text-light">Contact Sales for Price</span>',
      premium: '<span class="text-sm text-light">Contact Sales for Price</span>'
    },
    {
      title: 'Advance Customization',
      plus: '-',
      pro: '-',
      premium: '<span class="text-sm text-light">Contact Sales for Price</span>'
    }

];
